const StatusOptions = {
  PLANNED: "planned",
  SENT: "sent",
  ALL: "all",
};

export { StatusOptions };
